import React, { useRef } from 'react';
import classNames from 'classnames';
import Dropdown from './Dropdown';
import { Button } from '../BootstrapComponents/BootstrapComponents';

export default function DropdownList(props) {
  const {
    label,
    className,
    children,
    disabled = false,
    menuClassName = '',
    buttonClassName = '',
    variant = 'custom',
  } = props;

  const anchorElement = useRef(null);
  return (
    <div className={classNames('dropdown-list', className)}>
      <Dropdown usePortal disabled={disabled}>
        <Dropdown.Toggle
          className="multiple-select-toggle"
          target={anchorElement}
        >
          <Button
            variant={variant}
            className={classNames('white-button', { disabled }, buttonClassName)}
            setRef={anchorElement}
          >
            {label}
          </Button>
        </Dropdown.Toggle>
        <Dropdown.Menu className={classNames('dropdown-list-menu', menuClassName)} anchorElement={anchorElement}>
          {children}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
